import * as fromAddProductSolution from './add-product-solution.reducer';
import * as fromGetRiskCategory from './get-risk-factor.reducer';
import * as fromGetCurrentFactSheet from './get-current-factsheet.reducer';
import * as fromGetPreviousFactSheet from './get-previous-factsheet.reducer';
import * as fromSearchProjectSolution from './search-product-solution.reducer';
import * as fromUploadFactSheet from './upload-factsheet.reducer';
import * as fromGetProductSoliutions from './get-product-solutions.reducer';
import * as fromGetBenchmarks from './get-benchmarks.reducer';
import * as fromGetAssetManagers from './get-asset-managers.reducer';
import * as fromSearchBenchmarks from './search-benchmarks.reducer';
import * as fromSelectedProductSolution from './get-selected-product-solution.reducer';
import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';

export const addProductSolutionFeatureKey = 'productSolutions';

export interface ProductSolutionState {
  [fromAddProductSolution.addProductSolutionFeatureKey]: fromAddProductSolution.State;
  [fromGetRiskCategory.getRiskFactorFeatureKey]: fromGetRiskCategory.State;
  [fromGetCurrentFactSheet.getCurrentFactsheetFeatureKey]: fromGetCurrentFactSheet.State;
  [fromGetPreviousFactSheet.getPreviousFactsheetFeatureKey]: fromGetPreviousFactSheet.State;
  [fromSearchProjectSolution.searchProductSolutionFeatureKey]: fromSearchProjectSolution.State;
  [fromUploadFactSheet.uploadFactsheetFeatureKey]: fromUploadFactSheet.State;
  [fromGetProductSoliutions.getProductSolutionsFeatureKey]: fromGetProductSoliutions.State;
  [fromGetBenchmarks.getBenchmarksFeatureKey]: fromGetBenchmarks.State;
  [fromGetAssetManagers.getAssetManagersFeatureKey]: fromGetAssetManagers.State;
  [fromAddProductSolution.addProductSolutionFeatureKey]: fromAddProductSolution.State;
  [fromSearchBenchmarks.searchBenchmarksFeatureKey]: fromSearchBenchmarks.State;
  [fromSelectedProductSolution.getSelectedProductSolutionFeatureKey]: fromSelectedProductSolution.State;
}

export interface State {
  [addProductSolutionFeatureKey]: ProductSolutionState;
}

export function reducers(state: ProductSolutionState | undefined, action: Action) {
  return combineReducers({
    [fromAddProductSolution.addProductSolutionFeatureKey]: fromAddProductSolution.reducer,
    [fromGetRiskCategory.getRiskFactorFeatureKey]: fromGetRiskCategory.reducer,
    [fromGetCurrentFactSheet.getCurrentFactsheetFeatureKey]: fromGetCurrentFactSheet.reducer,
    [fromGetPreviousFactSheet.getPreviousFactsheetFeatureKey]: fromGetPreviousFactSheet.reducer,
    [fromSearchProjectSolution.searchProductSolutionFeatureKey]: fromSearchProjectSolution.reducer,
    [fromUploadFactSheet.uploadFactsheetFeatureKey]: fromUploadFactSheet.reducer,
    [fromGetProductSoliutions.getProductSolutionsFeatureKey]: fromGetProductSoliutions.reducer,
    [fromGetBenchmarks.getBenchmarksFeatureKey]: fromGetBenchmarks.reducer,
    [fromGetAssetManagers.getAssetManagersFeatureKey]: fromGetAssetManagers.reducer,
    [fromSearchBenchmarks.searchBenchmarksFeatureKey]: fromSearchBenchmarks.reducer,
    [fromSelectedProductSolution.getSelectedProductSolutionFeatureKey]: fromSelectedProductSolution.reducer
  })(state, action);
}

export const selectProjectSolutionState = createFeatureSelector<State, ProductSolutionState>(addProductSolutionFeatureKey);

export const selectAddProductSolutionState = createSelector(
  selectProjectSolutionState,
  state => state[fromAddProductSolution.addProductSolutionFeatureKey]
);

export const selectGetRiskCategoryState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetRiskCategory.getRiskFactorFeatureKey]
);

export const selectGetCurrentFactSheetState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetCurrentFactSheet.getCurrentFactsheetFeatureKey]
);

export const selectGetPreviousFactSheetState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetPreviousFactSheet.getPreviousFactsheetFeatureKey]
);

export const selectSearchProjectSolutionState = createSelector(
  selectProjectSolutionState,
  state => state[fromSearchProjectSolution.searchProductSolutionFeatureKey]
);

export const selectGetProductSolutionState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetProductSoliutions.getProductSolutionsFeatureKey]
);

export const selectGetBenchmarksState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetBenchmarks.getBenchmarksFeatureKey]
);

export const selectGetAssetManagersState = createSelector(
  selectProjectSolutionState,
  state => state[fromGetAssetManagers.getAssetManagersFeatureKey]
);

export const selectSearchBenchmarkState = createSelector(
  selectProjectSolutionState,
  state => state[fromSearchBenchmarks.searchBenchmarksFeatureKey]
);

export const selectedProductSolutionState = createSelector(
  selectProjectSolutionState,
  state => state[fromSelectedProductSolution.getSelectedProductSolutionFeatureKey]
);
